export type DiscoverySearchLike = Record<string, unknown>

const ACTIVE_FILTER_KEYS = [
  'q',
  'budget',
  'categoryId',
  'nonSmoking',
  'hasPrivateRoom',
  'kidsAllowed',
  'favoritesOnly',
] as const

const RESET_FILTER_KEYS = [
  ...ACTIVE_FILTER_KEYS,
  'shopId',
  'onlyShowSelected',
] as const

export function countActiveDiscoveryFilters(search: DiscoverySearchLike): number {
  return ACTIVE_FILTER_KEYS.reduce((count, key) => {
    const value = search[key]

    if (typeof value === 'string') return value.trim() ? count + 1 : count
    if (typeof value === 'number') return Number.isFinite(value) ? count + 1 : count
    if (value === true) return count + 1

    return count
  }, 0)
}

export function resetDiscoveryFilters<T extends DiscoverySearchLike>(search: T): T {
  return RESET_FILTER_KEYS.reduce(
    (next, key) => ({ ...next, [key]: undefined }),
    { ...search },
  ) as T
}

export function clearDiscoverySelection<T extends DiscoverySearchLike>(search: T): T {
  return {
    ...search,
    shopId: undefined,
    onlyShowSelected: undefined,
  }
}
